import { api, getDeviceId } from './api';
import type {
  AuthSession,
  LoginRequest,
  PublicUser,
  SMSChallenge,
  SendSMSCodeRequest
} from '../types';

export const authService = {
  sendCode(input: Omit<SendSMSCodeRequest, 'device_id'>, signal?: AbortSignal) {
    return api.post<SMSChallenge>('/auth/sms/send', { ...input, device_id: getDeviceId() }, signal);
  },
  login(input: Omit<LoginRequest, 'device_id'>, signal?: AbortSignal) {
    return api.post<AuthSession>('/auth/login', { ...input, device_id: getDeviceId() }, signal);
  },
  // 首次页面加载只探测已有会话，匿名访问不应主动打断用户填写表单。
  current(signal?: AbortSignal) {
    return api.get<PublicUser>('/auth/current', signal, { notifyUnauthorized: false });
  },
  logout(signal?: AbortSignal) {
    return api.post<null>('/auth/logout', undefined, signal);
  }
};
